/**
 * @author      hugo@zumper.com (Hugo Pineda)
 * @copyright   Copyright (c) 2021, Zumper
 */

import { css } from '@emotion/react'

export const image = css`
  background-color: #f3f3f3;
  width: 100%;
  height: 100%;
  object-fit: cover;
`

export const noImage = css`
  width: 100%;
  height: 100%;

  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;

  transition: transform 0.15s;
`
